import { useRef } from "react";

// Cierra un modal al pinchar en el fondo, pero solo si el clic empieza y acaba
// ahi. El evento click salta en el ancestro comun del punto donde se pulsa y
// donde se suelta, asi que sin esta comprobacion arrastrar el raton desde
// dentro de la ventana hasta fuera, al seleccionar texto por ejemplo, cerraria
// el modal.
const useOverlayClose = (onClose) => {
  const hasStartedOnOverlay = useRef(false);

  return {
    onMouseDown: (e) => {
      hasStartedOnOverlay.current = e.target === e.currentTarget;
    },
    onClick: (e) => {
      const shouldClose = hasStartedOnOverlay.current && e.target === e.currentTarget;
      hasStartedOnOverlay.current = false;
      if (shouldClose) onClose();
    },
  };
};

export default useOverlayClose;
